/**
 * Home score
 *
 * @param match
 * @returns
 */
export function homeScore(match) {
    return match.hScore || 0;
}
/**
 * Visitor score
 *
 * @param match
 * @returns
 */
export function visitorScore(match) {
    return match.vScore || 0;
}
//# sourceMappingURL=match-details.js.map